module.exports = __webpack_public_path__ + "static/media/action_check.16f5b80d.mp3";